export const logNotFoundPage = () => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'website_error',
    error_message: '404 Page',
    error_source: 'user',
    error_level: 'red',
  });
};

export const logErrorPage = (errorCode: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'website_error',
    error_message: errorCode + ' Page',
    error_source: 'user',
    error_level: 'red',
  });
};
export const logFormErrors = (form: string, errorSteps: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'website_error',
    error_message: form, // Doldurulan formun adı gönderilmelidir, İletişim Form, Rezervasyon Bilgileri Form, Sign Up Form, Login Form, Payment Form vs.
    error_step: errorSteps, // Hata alınan input alanının adı gönderilmelidir
    error_source: 'user', // Hata kullanıcı kaynaklı ise user, site veya api veya server kaynaklı ise site veya api veya server şeklinde gönderilmelidir
    error_level: 'green', // hatanın önem derecesine göre bir değer gönderilmelidir, green en az önemli hata, yellow orta derecede önemli hata ve red önemli hata olacak şekilde
  });
};
export const logApiErrors = (page: string, errorMessage: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'website_error',
    error_message: errorMessage, // Hata mesajı gönderilmelidir
    error_step: `${page} Page`, // Hata alınan sayfa başlığı gönderilmelidir
    error_source: 'system', // Hata kullanıcı kaynaklı ise user, site veya api veya server kaynaklı ise site veya api veya server şeklinde gönderilmelidir
    error_level: 'red', // hatanın önem derecesine göre bir değer gönderilmelidir, green en az önemli hata, yellow orta derecede önemli hata ve red önemli hata olacak şekilde
  });
};
